import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import asyncThunks from '../async-thunks';
import { CustomerGroupSelectorState } from '../types';

const putContext = (
  builder: ActionReducerMapBuilder<CustomerGroupSelectorState>,
) => {
  builder.addCase(
    asyncThunks.putContext.fulfilled,
    (state: CustomerGroupSelectorState, action) => {
      const customerContextChangedEvent = new CustomEvent(
        'customer-context-changed',
        {
          detail: action.payload,
        },
      );
      window.dispatchEvent(customerContextChangedEvent);

      state.context = action.payload;
      window.location.reload();
    },
  );
  builder.addCase(
    asyncThunks.putContext.rejected,
    (state: CustomerGroupSelectorState) => {
      state.isError = true;
    },
  );
};

export default putContext;
